{
  "fields": {
    "confirmPassword": "Confirm password",
    "email": "Email",
    "emailAddress": "Email address",
    "firstName": "First name",
    "fullName": "Full name",
    "lastName": "Last name",
    "newPassword": "New password",
    "password": "Password"
  },
  "forgotPassword": {
    "backToLoginButton": "Back to login",
    "didntReceive": "Didn't receive the email?",
    "resend": "Click here to resend",
    "sentSubtitle": "Please check your inbox, spam, and promotions folders",
    "sentTitle": "Check your email",
    "submit": "Send reset instructions",
    "subtitle": "Enter your email below and we'll send you instructions to reset your password.",
    "title": "Forgot your password?",
    "whatNextBody": "We'll send you a password reset link that expires in 10 minutes. Click the link in the email to create a new password.",
    "whatNextTitle": "What happens next"
  },
  "layout": {
    "features": {
      "growSleep": {
        "desc": "Your streams run continuously, building your audience",
        "title": "Grow while you sleep"
      },
      "multiPlatform": {
        "desc": "YouTube, Twitch, Kick — all at once",
        "title": "Multi-platform"
      },
      "preRecorded": {
        "desc": "Turn your videos into 24/7 live streams",
        "title": "Pre-recorded → Live"
      }
    },
    "heroSubtitle": "Join thousands of creators running non-stop live streams on YouTube, Twitch, and Kick.",
    "heroTitle": "Stream 24/7. Grow effortlessly.",
    "tagline": "Your 24/7 live streaming platform",
    "trustBadges": {
      "liveChat": "Live chat",
      "secure": "Secure",
      "support": "24/7 support"
    }
  },
  "login": {
    "forgotPasswordLink": "Forgot password?",
    "signupLink": "Create account",
    "signupPrompt": "Don't have an account?",
    "submit": "Log in",
    "subtitle": "Enter your details to log in.",
    "title": "Welcome back"
  },
  "notifications": {
    "accountVerified": "Account verified",
    "emailSent": "Email sent",
    "passwordUpdated": "Password updated"
  },
  "placeholders": {
    "confirmNewPassword": "Confirm new password",
    "confirmPassword": "Confirm password",
    "country": "Select your country",
    "email": "example@example.com",
    "firstName": "First name",
    "fullName": "Enter your full name",
    "lastName": "Last name",
    "newPassword": "Enter new password",
    "password": "**********"
  },
  "resetPassword": {
    "checks": {
      "lowercase": "Lowercase",
      "minLength": "8+ characters",
      "number": "Number",
      "special": "Special char",
      "uppercase": "Uppercase"
    },
    "loginLink": "Log in",
    "rememberPrompt": "Remember your password?",
    "strength": {
      "medium": "Medium",
      "strong": "Strong",
      "weak": "Weak"
    },
    "strengthLabel": "Password strength",
    "submit": "Set new password",
    "subtitle": "Enter your new password below. Make it strong and hard to guess.",
    "tips": {
      "avoid": "Avoid common words or patterns",
      "case": "Mix uppercase and lowercase letters",
      "length": "Use at least 8 characters",
      "numbers": "Include numbers and special characters"
    },
    "tipsTitle": "Password tips",
    "title": "Set a new password"
  },
  "shared": {
    "backToLogin": "Back to login"
  },
  "signup": {
    "loginLink": "Log in",
    "loginPrompt": "Already have an account?",
    "submit": "Sign up",
    "subtitle": "Join thousands of creators already streaming 24/7",
    "title": "Create an account"
  },
  "verify": {
    "codeLabel": "Verification code",
    "didntReceive": "Didn't receive an email?",
    "legacyCodeNotice": "If your emailed code has 4 digits, it's expired — press Resend for a new 6-digit code.",
    "logout": "Log out",
    "or": "Or",
    "resend": "Resend",
    "submit": "Submit",
    "subtitleWithEmail": "We've sent a verification code to <0>{{email}}</0> (if you can't find the email in your inbox, please check your spam folder)",
    "title": "Verify your email",
    "digitLabel": "Digit {{n}} of {{total}}"
  },
  "terms": {
    "agreement": "By continuing, you agree to the <0>terms and conditions</0>, <1>privacy policy</1> and <2>disclaimer</2>."
  },
  "google": {
    "loading": "Loading Google sign-in…",
    "signingIn": "Signing you in…",
    "unavailable": "Google sign-in could not load. You can use email or try again.",
    "retry": "Try again",
    "orEmail": "or use email",
    "linkTitle": "Connect your Google account",
    "linkDescription": "Enter your existing Streaminal password to connect this Google account securely.",
    "password": "Streaminal password",
    "linkSubmit": "Connect and continue"
  }
}
